import { render } from "./ConnectionView.vue?vue&type=template&id=60b0b08e"
import script from "./ConnectionView.vue?vue&type=script&lang=js"
export * from "./ConnectionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__